import { localPushApi } from '../api/localPushApi';
import { useBaseQuery, useBaseMutation, useNoDataMutation, useInvalidateQueries } from './useBaseQuery';
import {
    LocalPushSchedule,
    CreateLocalPushScheduleRequest,
    UpdateLocalPushScheduleRequest,
} from '../types/localPush';
import NoDataResponse from '../models/noDataResponse';

export const localPushKeys = {
    all: ['localPush'] as const,
    lists: () => [...localPushKeys.all, 'list'] as const,
};

export const useLocalPushSchedules = () => {
    return useBaseQuery<LocalPushSchedule[]>(
        localPushKeys.lists(),
        async () => {
            const result = await localPushApi.getAll();
            return result ?? [];
        },
        { staleTime: 30 * 1000 },
    );
};

export const useCreateLocalPushSchedule = () => {
    const { invalidate } = useInvalidateQueries();
    return useBaseMutation<CreateLocalPushScheduleRequest, LocalPushSchedule>(
        (data) => localPushApi.create(data),
        {
            onSuccess: () => {
                invalidate(localPushKeys.lists());
            },
        },
    );
};

export const useUpdateLocalPushSchedule = () => {
    const { invalidate } = useInvalidateQueries();
    return useBaseMutation<{ id: number; data: UpdateLocalPushScheduleRequest }, LocalPushSchedule>(
        ({ id, data }) => localPushApi.update(id, data),
        {
            onSuccess: () => {
                invalidate(localPushKeys.lists());
            },
        },
    );
};

export const useDeleteLocalPushSchedule = () => {
    const { invalidate } = useInvalidateQueries();
    return useNoDataMutation<number>(
        (id) => localPushApi.delete(id) as Promise<NoDataResponse>,
        {
            onSuccess: () => {
                invalidate(localPushKeys.lists());
            },
        },
    );
};
